import type { Locale } from '@/constants/i18n'

export interface PluralForms {
    zero?: string
    one?: string
    two?: string
    few?: string
    many?: string
    other: string
}

export const pl = (forms: PluralForms): PluralForms => forms

const RULES: Partial<Record<Locale, Intl.PluralRules>> = {}

const rulesFor = (locale: Locale): Intl.PluralRules => {
    if (!RULES[locale]) RULES[locale] = new Intl.PluralRules(locale)

    return RULES[locale] as Intl.PluralRules
}

export const fmt = (template: string, values: Record<string, string | number> = {}): string =>
    template.replace(/\{(\w+)\}/g, (match, key: string) => (key in values ? String(values[key]) : match))

export const plural = (locale: Locale, forms: PluralForms, count: number, values: Record<string, string | number> = {}): string => {
    const category = rulesFor(locale).select(count) as keyof PluralForms
    const template = forms[category] ?? forms.other

    return fmt(template, { n: count, ...values })
}
